<template>
  <span>
    <v-progress-linear
      v-if="logsResIsLoading"
      color="blue"
      indeterminate
    />
    <v-data-table
      :headers="headers"
      :items="logRows"
      hide-default-footer
      fixed-header
      height="300"
      single-expand
      :expanded.sync="expanded"
      no-data-text="Нет данных для отображения"
      item-key="start_date"
      show-expand
      dense
    >
      <template v-slot:top>
        <div class="table-top">
          {{ task.represents ? 'Объект - ' + task.represents[0].name + ', ' : '' }}
          {{ task.point ? 'Точка учёта - ' + task.point[0].address + ' - ' + task.point[0].name + ', ' : '' }}
          Номер счётчика - {{ task.counter_num }}
        </div>
      </template>
      <template v-slot:item.start_date="{item}">
        <span class="nwrp">{{ item.start_date | moment("DD/MM/YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.success="{item}">
        <div :class="{ 'task-error': !item.success }">{{ statusText(item.success) }}</div>
      </template>
<!--      <template-->
<!--        slot="item"-->
<!--        slot-scope="props"-->
<!--      >-->
<!--        <tr-->
<!--          :class="{ success_log: props.item.success, error_log: !props.item.success}"-->
<!--        >-->
<!--          <td-->
<!--            class="text-right"-->
<!--            width="100px"-->
<!--          >-->
<!--            <span class="nwrp">{{ props.item.start_date | moment("DD/MM/YYYY HH:mm:ss") }}</span>-->
<!--          </td>-->
<!--          <td width="100%"> {{ statusText(props.item.success) }}</td>-->
<!--        </tr>-->
<!--      </template>-->

      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          class="px-0"
        >
          <v-data-table
            :headers="headersActions"
            :items="getitems(item.log)"
            hide-default-footer
            hide-default-header
            item-key="name"
            dense
          >
            <tr
              slot="item"
              slot-scope="props"
            >
              <td class="text-right">{{ props.item.date }}</td>
              <td class="text-right">{{ props.item.text }}</td>
            </tr>
          </v-data-table>
        </td>
      </template>

    </v-data-table>
  </span>
</template>

<script>
export default {
  name: 'TaskLogs',
  props: {
    task: {
      required: true
    }
  },
  data () {
    return {
      expanded: [],
      logsResIsLoading: false,
      headers: [
        {
          text: 'Дата и время',
          sortable: false,
          value: 'start_date'
        },
        { text: 'Результат', value: 'success' },
        { text: '', value: 'data-table-expand' }
      ],
      logRows: [],
      headersActions: [
        { text: 'date', value: 'date' },
        { text: 'text', value: 'text' }
      ]
    }
  },
  watch: {
    'task.counter_task_id' (val) {
      this.updateLog(val)
    }
  },
  created () {
    this.updateLog(this.task.counter_task_id)
  },
  methods: {
    updateLog (id) {
      if (!id) {
        return
      }
      this.logRows = []
      this.logsResIsLoading = true
      this.axios.get(`/api/tasks_logs/?task_id=${id}`)
        .then((response) => {
          this.logRows = response.data.results
          this.logsResIsLoading = false
        })
        .catch((err) => {
          this.logsResIsLoading = false
          console.log(err)
        })
    },
    getitems (log) {
      var res = []
      log.forEach(function (row) {
        res.push({ 'date': row[0], 'text': row[1] })
      })
      return res
    },
    statusText (isSuccess) {
      return isSuccess ? 'Выполнено' : 'Ошибка'
    }
  }
}
</script>

<style scoped>
  .success_log {
    background-color: #00e67636;
  }
  .error_log {
    background-color: #ff8a8036;
  }
  .nwrp {
    white-space: nowrap;
  }
  .task-error {
    height: 100%;
    margin: 0 -16px;
    padding: 0 16px;
    background-color: #f5989830;
  }
  .table-top {
    padding: 5px 16px 0;
  }
</style>




// WEBPACK FOOTER //
// src/shared-components/TaskLogs.vue